import {
  ContextWorkbenchEditorFilesListNode,
  ContextWorkbenchEditorFilesListNodeId,
} from "../contextWorkbenchEditorFilesListNode";
import { ContextWorkbenchEntity } from "../contextWorkbenchEntity";
import { ContextWorkbenchFileId } from "../contextWorkbenchFile";

export function getEditorFilesListNodeForFile(
  fileId: ContextWorkbenchFileId,
): ContextWorkbenchEditorFilesListNode.File {
  const id = getEditorFilesListNodeIdForFile(fileId);
  return {
    id,
    type: ContextWorkbenchEditorFilesListNode.Type.File,
    fileId,
  };
}

export function getEditorFilesListNodeForAsyncPlaceholder<E extends Error>(
  entityType: ContextWorkbenchEntity.Type,
  loading: boolean,
  error: E | undefined,
): ContextWorkbenchEditorFilesListNode.AsyncPlaceholder {
  const id = getEditorFilesListNodeIdForAsyncPlaceholder(entityType);
  return {
    id,
    type: ContextWorkbenchEditorFilesListNode.Type.AsyncPlaceholder,
    entityType,
    loading,
    error,
  };
}

// --- NodeId ---
// should be stable to a given node type

function getEditorFilesListNodeIdForFile(
  fileId: ContextWorkbenchFileId,
): ContextWorkbenchEditorFilesListNodeId {
  return ContextWorkbenchEditorFilesListNodeId.check(`file:${fileId}`);
}

function getEditorFilesListNodeIdForAsyncPlaceholder(
  entityType: ContextWorkbenchEntity.Type,
): ContextWorkbenchEditorFilesListNodeId {
  return ContextWorkbenchEditorFilesListNodeId.check(
    `async-placeholder:${entityType}`,
  );
}
